/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Folder': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.175 4.32h4.605c5.535 0 8.235 2.955 8.22 9.015v7.305c0 5.79-3.57 9.36-9.375 9.36H9.36C3.585 30 0 26.43 0 20.625V9.36C0 3.15 2.76 0 8.205 0h2.37c1.397-.015 2.7.63 3.555 1.725l1.32 1.755c.42.525 1.05.84 1.725.84zm-9.12 15.615h13.89c.615 0 1.11-.51 1.11-1.125a1.11 1.11 0 00-1.11-1.125H8.055c-.63 0-1.125.495-1.125 1.125 0 .615.495 1.125 1.125 1.125z" _fill="#9BC225"/>'
  }
})
